import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-params',
    templateUrl: './params.component.html',
    styleUrls: ['./params.component.scss']
})
export class ParamsComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
    }
}
